export default __webpack_public_path__ + "static/media/hdextension.965ccd21.png";